// Google Analytics 4 event helper + UTM capture/persistence.
// Mirrors key events to the backend for UTM attribution records.
import { recordEvent } from "@/lib/api";

const UTM_KEYS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
];
const STORAGE_KEY = "cv_utm";

// Capture UTM params on entry and persist them for the session.
export function captureUTM() {
  try {
    const params = new URLSearchParams(window.location.search);
    const found = {};
    let has = false;
    UTM_KEYS.forEach((k) => {
      const v = params.get(k);
      if (v) {
        found[k] = v;
        has = true;
      }
    });
    if (has) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(found));
    }
  } catch (e) {
    /* no-op */
  }
  return getUTM();
}

export function getUTM() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch (e) {
    return {};
  }
}

// Core dispatcher: fires gtag + persists to backend with UTM attribution.
export function track(event, params = {}) {
  const utm = getUTM();
  const payload = { ...params, ...utm };
  try {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", event, payload);
    }
  } catch (e) {
    /* no-op */
  }
  // Mirror to backend (best effort, never blocks UI)
  try {
    recordEvent({ event, params, utm }).catch(() => {});
  } catch (e) {
    /* no-op */
  }
}

export function trackPageView(path) {
  const utm = getUTM();
  try {
    if (typeof window.gtag === "function") {
      window.gtag("event", "page_view", {
        page_path: path,
        page_location: window.location.href,
        ...utm,
      });
    }
  } catch (e) {
    /* no-op */
  }
  try {
    recordEvent({ event: "page_view", params: { page_path: path }, utm }).catch(
      () => {}
    );
  } catch (e) {
    /* no-op */
  }
}
